var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98 11.466C7.98 12.936 6.902 14.112 4.732 14.196V15.414H3.892V14.168C1.946 13.972 0.462 12.838 0.364 10.808H1.792C1.904 12.026 2.604 12.768 3.892 12.936V9.59C3.878 9.59 3.864 9.576 3.85 9.576C2.394 9.184 0.756 8.582 0.756 6.902C0.756 5.32 1.96 4.284 3.892 4.214V3.22H4.732V4.256C6.426 4.466 7.616 5.53 7.728 7.336H6.3C6.174 6.286 5.642 5.684 4.732 5.502V8.484C6.65 9.044 7.98 9.534 7.98 11.466ZM2.198 6.762C2.198 7.588 2.884 7.91 3.892 8.232V5.446C2.856 5.502 2.198 5.978 2.198 6.762ZM4.732 9.828V12.978C6.062 12.908 6.538 12.32 6.538 11.508C6.538 10.584 5.95 10.206 4.732 9.828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.ba9ce1e22a2dbe67581f5ee603c9b9d3.svg";
export { ForwardRef as ReactComponent };